import { GET, POST } from 'utils/requests.utils'

const BASE_URL = '/cabinet/sync_webhook_logs'

export const fetchList = (data) => GET(BASE_URL, data)

export const resendLog = (id) => POST(`${BASE_URL}/${id}/resend_log`)

export default fetchList
